import VectorSource from "ol/source/Vector";
import mapConfig from "../../map.config.json";
import {TopoJSON} from "ol/format";
import VectorLayer from "ol/layer/Vector";
import {Fill, Stroke, Style} from "ol/style";
import Text from "ol/style/Text";

/**
 * Definisce il sorgente per il layer dei comuni
 * @type {*|VectorSource}
 */
const comuniLayerSource = new VectorSource({
    url: mapConfig.basePath + 'comuni.topojson.json',
    format: new TopoJSON()
});
/**
 * Definisce il layer dei comuni
 * @type {*|VectorLayer}
 */
export const comuniLayer = new VectorLayer({
    source: comuniLayerSource,
    name: 'comuni',
    style: new Style({
        fill: new Fill({
            color: '#CCCCCC'
        }),
        stroke: new Stroke({
            color: '#FFFFFF',
            width: 1
        })
    })
});


export function getComuniHlStyle(feature) {
    return new Style({
        fill: new Fill({
            color: 'transparent'
        }),
        stroke: new Stroke({
            color: '#FFFFFF',
            width: 2
        }),
        text: new Text({
            text: feature.values_.hover ? '' : feature.values_.nome,
            font: '12px "Titillium Web"',
            overflow: true,
            fill: new Fill({color: '#006699'}),
            stroke: new Stroke({color: '#FFFFFF', width: 2}),
            offsetX: 0,
            offsetY: 0
        })
    });
}
